import enviroment from "../enviroment";
//import moment_ from "moment";
//Add time zone EST
//import "moment-timezone";
import moment_ from "moment-timezone";
moment_.tz.setDefault(enviroment.timeZone);

const moment = moment_

export const prettyDate = ({date, format="YYYY-MM-DD HH:mm:ss"}) => {
  date = filterDate(date)
  if(!date){
    return "-";
  }

  const date_from_now = moment(date).fromNow();
  const date_complete = moment(date).format(format);
  return `${date_from_now} (${date_complete})`
}

const filterDate = (date) => {
  const optionsToNull = ['N/A'];
  if(optionsToNull.includes(date)){
    return null;
  }
  return date;
}

export const dateFormatting = (date) => {
  return date && moment(date).isValid() ? moment(date).format("MM/DD/YYYY HH:mm:ss") : "N/A";
};

export const whatIsMyTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
};

export default moment